import { GetterTree } from 'vuex'
import { ProxySettingsState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ProxySettingsState, RootState> = {
    proxySettings:state => state.proxySettings,
    proxySettingItem:state => state.proxySettingItem,
};
